export default "__VITE_ASSET__EBzB1grh__"